import { render, staticRenderFns } from "./mobileClient.vue?vue&type=template&id=cb013a56&scoped=true"
import script from "./mobileClient.vue?vue&type=script&lang=js"
export * from "./mobileClient.vue?vue&type=script&lang=js"
import style0 from "./mobileClient.vue?vue&type=style&index=0&id=cb013a56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb013a56",
  null
  
)

export default component.exports